<template>
  <EditingDialog
        :context="context"
        :useDifferentShowDialogProp="true"
        :showSnackbar="true"
        snackbarTextLangConst="lang_GENERAL_SNACKBAR_TEXT_CLICK_MAIN_SAVE_BUTTON"
        maxCardHeight="900"
    >
        <template v-slot:editForm>
            <v-row>
                <!-- title -->
                <v-col>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Title"
                        :items="instrumentationItems" 
                        :label="$t('lang_GENERIC_CAPTION_ITEM_TITLE')"
                        :selection="true"
                        rules="required"
                        :withMargin="false"
                        :clearable="false"
                        :alvqa="alvqa + '-dropdown-title'"
                    />
                </v-col>
                <!-- Instruments -->
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Instruments"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_INSTRUMENTS')"
                        :withMargin="false"
                        rules="required|positiveinteger"
                        :alvqa="alvqa + '-textfield-title'"
                    />
                </v-col>
            </v-row>
            <v-row>
                <!-- musicians -->
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Musicians"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_MUSICIANS')"
                        rules="positiveinteger"
                        :withMargin="false"
                        :alvqa="alvqa + '-textfield-musicians'"
                    />
                </v-col>
                <!-- Voices -->
                <v-col>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Voices"
                        :label="$t('lang_PUBLISHING_WORKS_CAPTION_VOICES')"
                        rules="positiveinteger"
                        :withMargin="false"
                        :alvqa="alvqa + '-textfield-voices'"
                    />
                </v-col>
            </v-row>
        </template>
    </EditingDialog>
</template>

<script>
import EditingDialog from '@/components/_dialogs/EditingDialog'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'

export default {
    name:"InstrumentationEditPanelDialog",
    components: {
        EditingDialog,
        BaseEditPageTextField,
        BaseEditPageDropdown
    },
    data() {
        return {
            context: "WorksInstrumentation",
            alvqa: "publishing-works-edit-form-instrumentation-panel-editing-dialog"
        }
    },
    computed: {
        instrumentationItems() { 
            let updatedItemsArray = []
            let itemsFromList = this.$store.getters.getWorksInstrumentation
            let itemsInDropdown = JSON.parse(JSON.stringify(this.$store.getters.getInstrumentations[this.$i18n.locale]))
            if(itemsInDropdown === undefined) {
                itemsInDropdown = this.$store.getters.getInstrumentations['en']
            }

            // Sorting
            itemsInDropdown.sort((a,b) => (a.text > b.text) ? 1 : (b.text > a.text) ? -1 : 0)

            //Creating new Array in which every item has an extra property 'disabled'
            itemsInDropdown.forEach(item =>{
                item['disabled']= false
                item['alvqa'] = 'dropdown-instrumentation-' + item.value.toLowerCase()
                item['text'] = item.text + ' (' + item.value + ')'
                updatedItemsArray.push(item)
            })

             //Comparing items in the list of added instruments with array of all items with disabled property
            for (const listItem of itemsFromList) {
                for (const updatedItem of updatedItemsArray) {
                    if(listItem.title === updatedItem.value){
                        updatedItem.disabled = true
                    }
                }
            }

            return updatedItemsArray
        },

    },
}
</script>

<style>

</style>